import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";

import * as net from "../../lib/net";
import Dt_Txt from "../../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Eko_Bets extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        this.state.paa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.tra = [];

        this.state.tot = {};
        this.state.tot.antal = "";
        this.state.tot.belopp = "";
        this.state.tot.resultat = "";

        this.state.today = new Date();
        var dts = format(this.state.today, "yyyy-MM-dd");
        this.state.tdts = dts;
        this.state.dts = dts;
    }
    componentDidMount(){
        this.st_art();
    }

    componentWillUnmount(){
    }

    onScroll(event) {
        var body = document.getElementById("web-body");
        if (body.scrollTop > 150) {
          this.setState({top: 0})
          this.setState({info: 'small'})
        } else {
          this.setState({top: 1})
          this.setState({info: 'big:'+body.scrollTop})
        }

        if (true) {
            var offset = body.scrollTop;
            var start = body.scrollTop;
            var slut = body.scrollTop + window.innerHeight;

            for(var mnuid of this.state.mnus) {
                const element = document.getElementById(mnuid);
                if(!element || (element == null) || (element == undefined)) continue;
                var eltop = element.offsetTop;
                var elbot = element.offsetTop + element.offsetHeight;
                var brc = eltop >= start && eltop <= slut;
                //if(!brc) brc = elbot >= start && elbot <= slut;
                if(brc) {
                    this.setState({mnu_sel: mnuid});
                    return;
                }
            }
        }
    }
    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        //if((row.r0ttyp != "P") && (row.r0ttyp != "B")) css.display = "none";
        //if((row.r0etyp == "NOTA")) css.display = "none";
        return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 225;
        css.overflow = "auto";
        return css;
    }
    dt_dts(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts });
    }

    st_art() {
        var self = this;

        if(this.state.dts == this.state.tdts) {
            self.st_act();
        }
        else
        {
            self.st_hist();
        }
    }
    st_act() {
        var self = this;

        var prm = {};
        prm.req = "pos.pos_eko.trh_stat_sum";
        prm.avd = this.state.avd;
        prm.fdat = this.state.dts;
        prm.tdat = this.state.dts;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
            .then(function(ret){
                ///alert(JSON.stringify(ret));

                var sto = ret.rco;
                var tot = {};
                tot.antal = sto.fsg_antal;
                tot.belopp = sto.fsg;
                //var tra = sto.plus;
                var paa = Object.values(sto.bets);
                self.setState({ paa: paa, tot: tot });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    st_hist() {
        var self = this;

        var prm = {};
        prm.req = "pos.pos_eko.trh_stat_sum";
        prm.avd = this.state.avd;
        prm.fdat = this.state.dts;
        prm.tdat = this.state.dts;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));

                var sto = ret.rco;
                var tot = {};
                tot.antal = sto.fsg_antal;
                tot.belopp = sto.fsg;
                //var tra = sto.plus;
                var paa = Object.values(sto.bets);
                self.setState({ paa: paa, tot: tot });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }

    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="web-content flex-column">


            <div className="d-flex flex-row justify-content-between">
                <div className="">BETAL STATISTIK</div>
            </div>
                <div className="flex-row justify-content-between">
                    <Dt_Txt dts={this.state.dts} getValue={(e)=> this.dt_dts(e) }/>
                    <div className="cdiblue" onClick={() => this.st_art() }>UPPDATERA</div>
                </div>
                <div className="flex">
                <table className="table table-bordered table-hover tb fixed_header">
                    <thead>
                    <tr>
                        <th>Text</th>
                        <th>Antal</th>
                        <th>Pris</th>
                    </tr>
                    </thead>
                    <tbody style={ this.tb_style() }>
                    { this.state.paa.map((row, key) =>
                    <tr key={key} style={ this.row_css(row) } onDoubleClick={() => this.row_open(row) }>
                        <td>{ row.text.toswe() }</td>
                        <td className="text-right">{ row.antal.toString().ztrim() }</td>
                        <td className="text-right">{ row.belopp.toString().cdipris() }</td>
                    </tr>
                    )}
                    <tr>
                        <th>Summa</th>
                        <th className="text-right">{ this.state.tot.antal.ztrim() }</th>
                        <th className="text-right">{ this.state.tot.belopp.cdipris() }</th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="">
                <div className="txt_14">Produkter : { this.state.paa.length }</div>
            </div>

         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default Eko_Bets;
